import { Checkbox, ListItem } from "@mui/material";
import React, { ReactNode } from "react";

interface CheckBoxItemListItemProps {
  item: any;
  checked: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>, item: any) => void;
  icon?: ReactNode;
}

const CheckBoxItemListItem = (
  props: React.PropsWithChildren<CheckBoxItemListItemProps>,
) => {
  const { item, checked, handleChange, children, icon } = props;

  return (
    <ListItem divider className="list-item">
      <Checkbox
        className="checkBox"
        checked={checked}
        onChange={(event) => handleChange(event, item)}
        inputProps={{ "aria-label": "controlled" }}
      />
      {icon}
      {children}
    </ListItem>
  );
};

export default CheckBoxItemListItem;
